// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"48065fbb","488":"e54615ff","968":"5bf7f2d3"}[chunkId] + ".chunk.js";
};